import { render, staticRenderFns } from "./ui-label.vue?vue&type=template&id=27061c2a&"
import script from "./ui-label.vue?vue&type=script&lang=ts&"
export * from "./ui-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports